// authService.js - Updated to handle JWT tokens
import { AUTH_CONFIG } from './config';

export const authService = {
  // Keep existing methods for backward compatibility
  getToken: () => {
    // First try to get JWT token
    const tokens = authService.loadTokens();
    if (tokens && tokens.access_token) {
      return tokens.access_token;
    }
    // Fallback to old token storage
    return localStorage.getItem(AUTH_CONFIG.tokenKey);
  },
  
  setToken: (token, expiry) => {
    localStorage.setItem(AUTH_CONFIG.tokenKey, token);
    localStorage.setItem(AUTH_CONFIG.tokenExpiryKey, expiry);
  },
  
  removeToken: () => {
    localStorage.removeItem(AUTH_CONFIG.tokenKey);
    localStorage.removeItem(AUTH_CONFIG.tokenExpiryKey);
    // Also clear JWT tokens
    authService.clearTokens();
  },
  
  isAuthenticated: () => {
    // First check JWT tokens
    const tokens = authService.loadTokens();
    if (tokens && tokens.expires_at) {
      return new Date().getTime() < tokens.expires_at;
    }
    
    // Fallback to old token check
    const token = localStorage.getItem(AUTH_CONFIG.tokenKey);
    const expiry = localStorage.getItem(AUTH_CONFIG.tokenExpiryKey);
    return token && expiry && new Date().getTime() < expiry;
  },
  
  // Add the initialization method inside the object
  initDevToken: () => {
    if (process.env.NODE_ENV === 'development') {
      localStorage.setItem(AUTH_CONFIG.tokenKey, 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IlRlc3QgVXNlciIsImlhdCI6MTY2MTg5MTIwMCwiZXhwIjoxNzkyMTI3MjAwfQ.6giwYb_5NR5mP5FTbQI-a_hzQgbY7WF1nvBGaxWsuKo');
      localStorage.setItem(AUTH_CONFIG.tokenExpiryKey, '1792127200000'); // Matching expiry timestamp in milliseconds
    }
  },
  
  // New JWT token methods
  loadTokens: () => {
    try {
      const tokensString = localStorage.getItem('auth_tokens');
      if (tokensString) {
        return JSON.parse(tokensString);
      }
    } catch (error) {
      console.error('Error loading tokens from localStorage:', error);
    }
    return null;
  },

  saveTokens: (tokens) => {
    try {
      localStorage.setItem('auth_tokens', JSON.stringify(tokens));
      
      // Also update legacy token storage for backward compatibility
      if (tokens.access_token) {
        authService.setToken(tokens.access_token, tokens.expires_at);
      }
    } catch (error) {
      console.error('Error saving tokens to localStorage:', error);
    }
  },

  clearTokens: () => {
    localStorage.removeItem('auth_tokens');
  },

  getRefreshToken: () => {
    const tokens = authService.loadTokens();
    if (!tokens) return null;
    return tokens.refresh_token;
  },
  
  getUserFromTokens: () => {
    const tokens = authService.loadTokens();
    if (!tokens) return null;
    return {
      id: tokens.user_id,
      email: tokens.email
    };
  }
};